import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { WorkflowType } from '../settings/interfaces/workflow'
import { ServerUrlService } from './server-url.service'

/** #13789 — workflows padrão + personalizados ativos, para o seletor do cadastro de totem. */
@Injectable({
  providedIn: 'root',
})
export class WorkflowService {
  private headers = {
    headers: {
      'Content-Type': 'application/json',
    },
  }

  constructor(private httpClient: HttpClient, private serverUrl: ServerUrlService) {}

  getWorkflows(): Observable<WorkflowType[]> {
    return this.httpClient.get<WorkflowType[]>(`${this.serverUrl.getUrl()}/workflows`, this.headers)
  }
}
